import { useState, useCallback } from 'react';

export const useResourceFilters = () => {
  const [agencyFilter, setAgencyFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');

  const handleAgencyFilterChange = useCallback((value: string) => {
    setAgencyFilter(value);
  }, []);

  const handleTypeFilterChange = useCallback((value: string) => {
    setTypeFilter(value);
  }, []);

  const handleCategoryFilterChange = useCallback((value: string) => {
    setCategoryFilter(value);
  }, []);

  return {
    agencyFilter,
    typeFilter,
    categoryFilter,
    handleAgencyFilterChange,
    handleTypeFilterChange,
    handleCategoryFilterChange,
  };
};
